/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableRolesDto
 */
export interface AvailableRolesDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableRolesDto
     */
    organizationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AvailableRolesDto
     */
    organizationName?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AvailableRolesDto
     */
    availableRoles: Array<string>;
}

/**
 * Check if a given object implements the AvailableRolesDto interface.
 */
export function instanceOfAvailableRolesDto(value: object): value is AvailableRolesDto {
    if (!('availableRoles' in value) || value['availableRoles'] === undefined) return false;
    return true;
}

export function AvailableRolesDtoFromJSON(json: any): AvailableRolesDto {
    return AvailableRolesDtoFromJSONTyped(json, false);
}

export function AvailableRolesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableRolesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
        'availableRoles': json['availableRoles'],
    };
}

export function AvailableRolesDtoToJSON(json: any): AvailableRolesDto {
    return AvailableRolesDtoToJSONTyped(json, false);
}

export function AvailableRolesDtoToJSONTyped(value?: AvailableRolesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'availableRoles': value['availableRoles'],
    };
}

